<template>
  <div>
    <v-layout wrap class="mt-4" style="display: flex; align-items: center">
      <v-flex xs9>
        <h3 class="grey--text">{{ $t('tremendous.bank_transfer_deposit_tank_image') }}</h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn v-if="!isEdit" fab outline small color="primary" @click="isEdit = true">
          <em class="fa fa-pencil-alt middle" />
        </v-btn>
      </v-flex>
    </v-layout>
    <div v-if="isEdit" class="py-4">
      <div style="max-width: 600px">
        <uploadfile
          v-model="input.deposit_bank_transfer_info_image"
          :height="250"
          @onUploaded="onUploaded"
        ></uploadfile>
      </div>
      <div class="text-xs-center mt-4">
        <template v-if="isEdit">
          <v-btn outline color="grey" @click="handleReset">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn depressed color="primary" @click="handleSaveContent">
            {{ $t('Save') }}
          </v-btn>
        </template>
      </div>
    </div>
    <template v-else>
      <div class="py-4">
        <template v-if="input.deposit_bank_transfer_info_image">
          <img
            :src="input.deposit_bank_transfer_info_image"
            alt
            class="responsive-img"
            style="border-radius: 10px; max-width: 600px"
          />
        </template>
        <template v-else>
          <img
            src="/static/img/assets/generic/generic_default_thumbnail.png"
            class="responsive-img"
            style="border-radius: 10px; max-width: 600px"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import { mapGetters } from 'vuex'

export default {
  components: {
    uploadfile
  },
  props: {
    init: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEdit: false,
      input: {
        deposit_bank_transfer_info_image: ''
      },
      cache_deposit_bank_transfer_info_image: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    init: {
      handler() {
        this.handleInitial()
      },
      deep: true
    }
  },

  created() {
    this.handleInitial()
  },

  methods: {
    handleInitial() {
      const vm = this
      if (vm.init && vm.init.deposit_bank_transfer_info_image) {
        vm.input.deposit_bank_transfer_info_image =
          vm.init.deposit_bank_transfer_info_image.contentvalue

        vm.cache_deposit_bank_transfer_info_image = Object.assign(
          {},
          vm.init.deposit_bank_transfer_info_image
        )
      }
    },
    handleReset() {
      this.input.deposit_bank_transfer_info_image = this.init.cache_deposit_bank_transfer_info_image
        ? this.init.cache_deposit_bank_transfer_info_image.contentvalue
        : ''
      this.isEdit = false
    },
    handleSaveContent() {
      const vm = this
      try {
        const data = {
          pageid: vm.selectedBot.pageid,
          contenttype: 'deposit_bank_transfer_info_image',
          datatype: 'textarea',
          contentvalue: vm.input.deposit_bank_transfer_info_image
            ? vm.input.deposit_bank_transfer_info_image
            : '',
          priority: null
        }

        vm.onSendRequest(data)
        vm.isEdit = false
      } catch (error) {
        console.error(error)
      }
    },
    onUploaded(image) {
      this.input.deposit_bank_transfer_info_image = image
    },
    onSendRequest(content) {
      try {
        api.updateConfig(content, function (error, _) {
          if (error) {
            console.error(error)
            return
          }
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/TremendousDepositTransferPayment.vue